import { useInputBindingPress } from '@sorrem-client/ui/hooks';
import { CHARACTER_HOME_TAB_IDS, CHARACTER_HOME_TABS, type CharacterHomeTab } from '../tabs/character-home-tabs';

/**
 * Each tab's key (`CHARACTER_HOME_TABS[tab].binding`) opens it; pressing the
 * open tab's key returns to Overview. Off while a character is being created
 * (`isEnabled` false).
 */
export function useCharacterHomeTabHotkeys(activeTab: CharacterHomeTab, isEnabled: boolean, onTabChange: (tab: CharacterHomeTab) => void): void {
    const toggleTab = (tabId: CharacterHomeTab): (() => void) | undefined => (isEnabled
        ? (): void => onTabChange(activeTab === tabId ? 'overview' : tabId)
        : undefined);
    // The tab table is a module constant, so this calls the hook the same number of times, in the same order, every render.
    for (const tabId of CHARACTER_HOME_TAB_IDS) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useInputBindingPress(CHARACTER_HOME_TABS[tabId].binding, toggleTab(tabId));
    }
}
